import { referralConstant } from '../constant';

export const referralAction = {
    getAllReferralSettings,
    getReferralSetting,
    getReferralTypeEnabled,
    getReferralMultiTier,
    getReferralBonusAnnouncement,
};

function getAllReferralSettings(settings) {
    return (dispatch) => {
        dispatch({
            type: referralConstant.GET_ALL_REFERRAL_SETTINGS,
            payload: settings,
        });
    };
}

function getReferralSetting(setting) {
    return (dispatch) => {
        dispatch({
            type: referralConstant.GET_REFERRAL_SETTING,
            payload: setting,
        });
    };
}

function getReferralTypeEnabled(data) {
    return (dispatch) => {
        dispatch({
            type: referralConstant.GET_REFERRAL_TYPE_ENABLED,
            payload: data,
        });
    };
}

function getReferralMultiTier(data) {
    return (dispatch) => {
        dispatch({
            type: referralConstant.GET_REFERRAL_MULTITIER,
            payload: data,
        });
    };
}

function getReferralBonusAnnouncement(settings) {
    return (dispatch) => {
        dispatch({
            type: referralConstant.GET_REFERRAL_BONUS_ANNOUNCEMENT,
            payload: settings,
        });
    };
}
